module.exports = __webpack_public_path__ + "res/4-img_bg.1dd9cb1392868618e0006d3f9176cfa1.png";